// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bih_j bih_i bih_bc bih_r bih_st","QualityCheckboxes__quality":"ex_b"};